import { ReactNode } from 'react';

import { Field } from 'react-final-form';

import { AutocompleteV2 } from '@cast/design-system';
import type { AutocompleteV2Props } from '@cast/design-system';

import { useControlsGroupState } from './controls-state';
import { useRffFormState } from '../hooks';
import { showErrorOnChange } from '../utils';

type OmitAutocompleteV2Props<Item> = Omit<AutocompleteV2Props<Item>, 'value'>;

type Props<Item> = {
  name: string;
  renderError?: (error: string | string[]) => ReactNode;
} & OmitAutocompleteV2Props<Item>;

export const RffAutocompleteV2 = <Item,>({
  disabled: propsDisabled,
  readOnly: propsReadOnly,
  name: propsName,
  onChange: propsOnChange,
  renderError,
  ...props
}: Props<Item>) => {
  const { mode } = useRffFormState();
  const { disabled, readOnly, name } = useControlsGroupState({
    disabled: propsDisabled,
    readOnly: propsReadOnly ?? mode === 'view',
    name: propsName,
  });

  return (
    <Field<string | null> name={name || propsName}>
      {({ input: { onChange, value }, meta }) => (
        // @ts-expect-error todo: come up with a better type solution
        <AutocompleteV2
          {...(props as unknown as OmitAutocompleteV2Props<Item>)}
          value={value || null}
          onChange={({ value, selectedItem }) => {
            onChange(value);
            propsOnChange?.({ value, selectedItem });
          }}
          disabled={disabled}
          readOnly={readOnly}
          success={meta.touched && meta.valid}
          error={
            showErrorOnChange(meta)
              ? renderError?.(meta.error) || meta.error
              : undefined
          }
        />
      )}
    </Field>
  );
};
